import axios from 'axios'
import { httpInstance } from '../../api'
import * as types from '../mutation-types'

const state = {
  admin_users: [],
  admin_user: {},
  accessible_menu: []
}

const getters = {
  getAccessibleMenu: state => {
    return state.accessible_menu
  }
}

const mutations = {
  [types.GET_ALL_ADMIN] (state, payload) {
    state.admin_users = payload
  },

  [types.SET_ACTIVE_ADMIN] (state, payload) {
    state.admin_user = payload
  },

  [types.SET_ACCESSIBLE_MENU] (state, payload) {
    state.accessible_menu = []
    let menuItems = []
    if (payload.length > 0) {
      payload.forEach(element => {
        element.menu_subs.forEach(sub => {
          menuItems.push(sub.id)
        })
      })
    }
    state.accessible_menu = menuItems
  },

  [types.ADD_ADMIN] (state, payload) {
    state.admin_users.push(payload)
  },

  [types.CHANGE_ADMIN] (state, payload) {
    let atIndex = state.admin_users.findIndex(admin => admin.id === payload.id)
    state.admin_users.splice(atIndex, 1)
    state.admin_users.splice(atIndex, 0, payload)
  },

  [types.CHANGE_ACCESSIBLE_MENU] (state, payload) {
    state.accessible_menu.push(payload)
  },

  [types.DELETE_ADMIN] (state, _id) {
    let atIndex = state.admin_users.findIndex(admin => admin.id === _id)
    state.admin_users.splice(atIndex, 1)
  }
}

const actions = {
  async fetchAllAdminUsers ({commit}) {
    commit(types.SET_LOADING, true)
    await httpInstance.get(`auth/list`).then(response => {
      commit(types.GET_ALL_ADMIN, response.data)
      commit(types.SET_LOADING, false)
    }).catch(error => {
      commit(types.SET_LOADING, false)
      console.log(error.response)
    })
  },

  async addNewAdminUser ({commit}, payload) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .post('auth/create-admin-user', payload.admin)
      .then(response => {
        commit(types.ADD_ADMIN, payload.admin)
        payload.menu.auth_id = response.data.id
        payload.menu.menu_sub_id.push(1, 10) // set dashbord and my profile menu default to all users
        httpInstance.post('menu/add-permission', payload.menu).then(res => {
          commit(types.LOAD_RESPONSE, res)
          commit(types.SET_LOADING, false)
        }).catch(err => {
          console.log(err.response)
        })
      })
      .catch(error => {
        commit(types.LOAD_RESPONSE, error.response)
        console.log(error.response)
        commit(types.SET_LOADING, false)
      })
  },

  async setActiveAdmin ({commit}, _id) {
    commit(types.SET_LOADING, true)
    await axios
    .all([
      httpInstance.get(`/auth/${_id}/get`),
      httpInstance.get(`menu/auth/${_id}/list`)
    ])
    .then(
      axios.spread((admin, menu) => {
        commit(types.SET_ACTIVE_ADMIN, admin.data)
        commit(types.SET_ACCESSIBLE_MENU, menu.data)
        commit(types.SET_LOADING, false)
      })
    ).catch(error => {
      console.log(error.response)
      commit(types.LOAD_RESPONSE, error.response)
      commit(types.SET_LOADING, false)
    })
  },

  async changeAdminUser ({commit}, payload) {
    commit(types.SET_LOADING, true)
    await axios
    .all([
      httpInstance
      .put(`/auth/${payload.admin.id}/update-profile`, {
        employee_id: payload.admin.employee_id,
        first_name: payload.admin.first_name,
        last_name: payload.admin.last_name,
        email: payload.admin.email,
        phone: payload.admin.phone,
        company_code: payload.admin.company_code
      }),
      httpInstance.put(`menu/auth/${payload.admin.id}/update-permission`, {menu_sub_id: payload.menu})
    ])
    .then(
      axios.spread((admin, menu) => {
        commit(types.CHANGE_ADMIN, admin.data)
        commit(types.SET_ACCESSIBLE_MENU, menu.data)
        commit(types.LOAD_RESPONSE, admin)
        commit(types.SET_LOADING, false)
      })
    ).catch(error => {
      console.log(error.response)
      commit(types.LOAD_RESPONSE, error.response)
      commit(types.SET_LOADING, false)
    })
  },

  async deleteAdminUser ({ commit }, _id) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .delete(`auth/${_id}/delete-admin-user`)
      .then(response => {
        commit(types.DELETE_ADMIN, _id)
        commit(types.LOAD_RESPONSE, response)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },

  async changeAdminPassword ({commit}, payload) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .post(`/auth/${payload.id}/change-password`, {
        new_password: payload.admin.new_password,
        retype_password: payload.admin.retype_password
      })
      .then(response => {
        commit(types.LOAD_RESPONSE, response)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/admin.js